"use client";

import {
  Box,
  Container,
  Flex,
  Heading,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  FcAbout,
  FcAssistant,
  FcCollaboration,
  FcDonate,
  FcGlobe,
  FcLandscape,
  FcManager,
  FcViewDetails,
} from "react-icons/fc";
import Layout from "../../../layout/Layout";
import { ApiCard } from "../../../components/card";

export default function GeocodeHome() {
  return (
    <Layout
      children={
        <Box p={4}>
          <Stack spacing={4} as={Container} maxW={"3xl"} textAlign={"center"}>
            <Heading fontSize={{ base: "2xl", sm: "4xl" }} fontWeight={"bold"}>
              Geocode APIs
            </Heading>
            <Text color={"gray.600"} fontSize={{ base: "sm", sm: "lg" }}>
              Convert addresses to latitude/longitude coordinates and
              vice-versa.
            </Text>
          </Stack>

          <Container maxW={"5xl"} mt={12}>
            <Flex flexWrap="wrap" gridGap={6} justify="center">
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Forward Geocode"}
                  icon={<Icon as={FcLandscape} w={10} h={10} />}
                  description={
                    "Converts the given address into latitude and longitude coordinates."
                  }
                  href={"geocode/forward"}
                />
              </Box>
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Reverse Geocode"}
                  icon={<Icon as={FcViewDetails} w={10} h={10} />}
                  description={"An address is returned for a set of latitude/longitude coordinates."}
                  href={"geocode/reverse"}
                />
              </Box>
            </Flex>
          </Container>
        </Box>
      }
    />
  );
}
